import React, { useState, useRef, useEffect, useContext } from 'react';
import { useDispatch, ReactReduxContext } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setMembershipData, socialLogin as socialLoginAction, updateFinalTargetLink, updateUser } from '../../services/actions/actions';
import { REDIRECT_URI, EDITOR_ALL_INONE_LINK, SOCIAL_LOGIN_GG_CLIENT_ID, SOCIAL_LOGIN_FB_APP_ID, PAID_SERVICES, MEMBERSHIP, POPUP_TYPES, DASHBOARD_LINK, APP_DOMAIN, LOGIN_LINK, COOKIE_DOMAIN, COVERLETTER_EXPERIENCE, REFRESH_LINK, QUICK_EDITOR, TP_REVIEW_URL } from '../../constants/constants';
import WpAPI from '../../WpApi';

import GoogleImage from '../../assets/images-new/icons/google.svg';
import FbImage from '../../assets/images-new/icons/fb.svg';
import AppleImage from '../../assets/images-new/icons/apple.svg'

import { 
    userCompletesSectionsDownloadsPrintsOrShares as userCompletesSectionsDownloadsPrintsOrSharesAction,
    setContextMenu
} from '../../services/actions/actions';
import {
    LoginSocialGoogle, 
    LoginSocialFacebook
} from 'reactjs-social-login';
import { usePopup } from '../../context/PopupContext';
import downloadResume from '../../downloadResume';
// import { identify as FullStoryIdentify } from '@fullstory/browser';
import { useUser } from '../../context/UserContext';
import { ucFirstWordOfSentence } from '../../helper';
import { useCoverLetter } from '../../context/CoverLetterContext';

import { encryptData } from '../../helper';
import jsCookie from 'js-cookie';

const SocialLogin = (props) => {
    const { store } = useContext(ReactReduxContext);
    const history = useHistory();
    const [msg, setmsg] = useState('')
    const dispatch = useDispatch();
    const [loader, setLoader] = useState({download: false, save: false, share: false, print: false});
    const [spinner, setSpinner] = useState(false);
    const popupbox = usePopup();
    const type = (window.location.pathname == DASHBOARD_LINK ? 'list' : 'currentResume');
    const entityType = (jsCookie.get('dashboard_tab', {domain: COOKIE_DOMAIN, path: "/"}) ?? "resume");
    const entityName = (entityType == 'resume' ? 'Resume' : 'Cover Letter');
    const {
        checkMembership,
        plan,
        user
    } = useUser();

    const mounted = useRef(false);

    const { login_action_initiated, } = useCoverLetter();
    // useEffect(() => {
    //     login_action_initiated && submitForm(document.getElementById('submit_button'));
    // }, [login_action_initiated]);

    useEffect(() => {
        mounted.current = true;
        WpAPI.isLoggedIn() && history.push('/');
        return () => {
            mounted.current = false;
        };
    }, []);

    useEffect(() => {
        popupbox.configurePopup(POPUP_TYPES);
    })

    const checkMembershipAction = (callback = false, params = false, forcechange = true) => {
        if(typeof callback == 'function' && mounted.current) setLoader({...loader, [callback.name]: true});
        checkMembership(() => {
            if(typeof callback == 'function'){
                callback(params);
                if(mounted.current) setLoader({...loader, [callback.name]: false});
            }
            const downloadOnAllinonePageLoad = (localStorage.getItem('downloadOnAllinonePageLoad') ?? false);
            if(localStorage.getItem('clickAction') && !downloadOnAllinonePageLoad) localStorage.removeItem('clickAction');
        }, forcechange);
    }

    const userCompletesSectionsDownloadsPrintsOrShares = () => {
        dispatch(userCompletesSectionsDownloadsPrintsOrSharesAction(store.getState().resume, type)).then(res => {
            if(res.completed){
                const ec = (PAID_SERVICES && store.getState().plan == 'pro' ? 'app_editor_finalizations' : 'app_editor_finalizations_free');
                const el = (
                    PAID_SERVICES && store.getState().plan == 'pro' 
                    ? 'User completes sections: Downloads, Prints or Shares' 
                    : 'Free user completes sections: tries to download, print, share'
                );
                ga4Track(ec, 'RT App', el)
            }
        })
    }

    const share = () => {
        if(PAID_SERVICES){
            if(store.getState().plan == 'pro'){
                popupbox.show('share', null, () => {
                    //do nothing..
                }, {resume: {...store.getState().resume, id: store.getState().currentResume}, user: store.getState().user, type: type})
            }else{
                //history.push(MEMBERSHIP);
                window.location.href = `${APP_DOMAIN}${MEMBERSHIP}`
            }
        }else{
            popupbox.show('share', null, () => {
                //do nothing..
            }, {resume: {...store.getState().resume, id: store.getState().currentResume}, user: store.getState().user, type: type})
        }
        userCompletesSectionsDownloadsPrintsOrShares();
    }

    const download = () => {
        // if(PAID_SERVICES){
        //     store.getState().plan == 'pro' 
        //     ? popupbox.show('download', null, () => downloadResumeHandler()) 
        //     : history.push(MEMBERSHIP);
        // }else{
        //     popupbox.show('download', null, () => downloadResumeHandler()) 
        // }
        /**
         * #775: Any logged in users can download the resume in the text format. 
         * Action: Removed the above code snippet having PAID_SERVICES and plan check.
         * Date: 2023-07-21
         */
        //This is coming from Quick Editor Traditional page. When user clicks the download button.
        const downloadOnAllinonePageLoad = (localStorage.getItem('downloadOnAllinonePageLoad') ?? false);
        if(store.getState().plan == 'pro' && downloadOnAllinonePageLoad){
            history.push(QUICK_EDITOR);
        }else{
            popupbox.show('download', null, () => {
                downloadResumeHandler();
                userCompletesSectionsDownloadsPrintsOrShares();
                localStorage.getItem('downloadOnAllinonePageLoad') && localStorage.removeItem('downloadOnAllinonePageLoad');
            }, {plan: store.getState().plan, entity:{type: entityType, name: entityName }, referrer:'signup'});
        }
    }

    const downloadResumeHandler = () => {
        downloadResume(store.getState(), user, () => { 
            popupbox.close('download');
            popupbox.show('askfor_trustpilot_review', null, () => {
                window.open( TP_REVIEW_URL, '_blank');
            });
            // popupbox.show('downloadcompletionbox', null, () => {
            //     window.location.href = `${APP_DOMAIN}${COVERLETTER_EXPERIENCE}`;
            // });
        }, store.getState().downloadFormat, {type: entityType, name: entityName});
    }

    const print = () => {
        // if (!navigator.onLine) {
        //     alert("You seem to be offline. Please try again later.");
        //     return false;
        // }else{
            if(PAID_SERVICES){
                if(store.getState().plan == 'pro'){
                    dispatch(setContextMenu({context_menu: false}));
                    window.print()
                }else{
                    //history.push(MEMBERSHIP);
                    //window.location.href = `${APP_DOMAIN}${MEMBERSHIP}`
                    dispatch(updateFinalTargetLink({link: MEMBERSHIP}));
                    setTimeout(() => {
                        history.push(REFRESH_LINK);
                    }, 100);
                }
            }else window.print();
        //}
        userCompletesSectionsDownloadsPrintsOrShares();
        const ec = (window.innerWidth < 769 ? 'app_quick_editor_print_mobile' : 'app_quick_editor_print');
        const el = (window.innerWidth < 769 ? 'Mobile Print' : 'Print');
        gaTrack('RT App', `Quick Editor`, el);
        ga4Track(ec, 'RT App', el);
    }
    const help = () => {
        window.location.href = `${APP_DOMAIN}/${DASHBOARD_LINK}`
    }
    const triggerLastAction = () => {
        const clickAction = (localStorage.getItem('clickAction') && typeof localStorage.getItem('clickAction') != 'undefined' ? localStorage.getItem('clickAction') : '');
        switch (clickAction) {
            case 'download':
                checkMembershipAction(download);
                break;
            case 'print':
                checkMembershipAction(print);
                break;
            case 'share':
                checkMembershipAction(share);
                break;
            case 'saveandnext':
                checkMembershipAction(saveAndNext);
                break;
            case 'help':
                help();
                break;
            default:
                checkMembershipAction();
                //do nothing..
                break;
        }
    }

    const saveAndNext = () => {
        if (PAID_SERVICES) {
            if (store.getState().plan == 'pro') {
                dispatch(updateFinalTargetLink({link: QUICK_EDITOR}));
                setTimeout(() => {
                    history.push(REFRESH_LINK);
                }, 100);
            } else {
                dispatch(updateFinalTargetLink({link: MEMBERSHIP}));
                setTimeout(() => {
                    history.push(REFRESH_LINK);
                }, 100);
                //history.push(MEMBERSHIP);
            }
        } else {
            dispatch(updateFinalTargetLink({link: QUICK_EDITOR}));
            setTimeout(() => {
				history.push(REFRESH_LINK);
			}, 100);
        }
    }

    const fullStoryIdentify = (email) => {
        let uId = email;
        let displayName = email;
        // FullStoryIdentify(uId, {
        //   displayName: displayName
        // });
    }

    const postLoginHandlers = (res, source) => {
        // call the tracking events post login/signup
        trackingEventsHandler(res, source)
        // save the resume/coverletter data post login/signup
        saveHandler()
        // load the resumes/coverletters post login/signup
        dataReloadHandler()
        // trigger the last clicked action post login/signup
        lastActionHandler()
        // final actions post login/signup
        finalActionsHandler()
    }

    const updateStateUserAndMembership = () => {
        WpAPI.isLoggedIn() && WpAPI.getLoginUserInfo().then(res => {
            dispatch(updateUser(res.data.user))
            const currentAccount = {
                plan: 'pro', 
                lastsync: Math.floor(Date.now() / 1000), 
                has_plan: true,
                plan_has_trial: false,
                plan_status: 'active'
            }
            dispatch(setMembershipData(currentAccount));
        })
    }

    const trackingEventsHandler = (res, source) => {
        if(res.user?.track_firstlogin){
            if(res.user.track_firstlogin == 'yes' && res.user.rb_firstlogin == 'yes'){
                let date = new Date().toJSON();
                ga4Track('app_registered_user_first_login', 
                    'RB App', 
                    `Registered User: First Login, Path:${window.location.pathname}, 
                    Email:${res.user.email}, 
                    Date:${date}`
                );
            }
        }
        if (props.hasOwnProperty('type') && props.type === 'popup') {
            if(res.msg == 'success'){
                if(res.account_type == 'returning'){
                    ga4Track(`app_all_login_points_user_logins`, 'RT App', 'User Logs In');
                    ga4Track(`app_editor_login_popup_login`, 'RT App', 'Login Popup: Logged in through popup');
                    ga4Track(`app_editor_login_popup_login_${source}`, 'RT App', `Login Popup: Logged in through ${source}`);
                }else if(res.account_type == 'new'){
                    ga4Track(`app_all_sign_up_points_user_signup`, 'RT App', 'User Signs Up');
                    ga4Track(`app_editor_login_popup_signup`, 'RT App', 'Login Popup: Signed up through popup');
                    ga4Track(`app_editor_login_popup_signup_${source}`, 'RT App', `Login Popup: Signed up in through ${source}`);
                }
            }
        }else if (props.hasOwnProperty('type') && props.type === 'page') {
            if(res.msg == 'success'){
                if(res.account_type == 'returning'){
                    ga4Track(`app_all_login_points_user_logins`, 'RT App', 'User Logs In');
                    ga4Track(`app_editor_login_popup_login`, 'RT App', 'Login Popup: Logged in through page');
                    ga4Track(`app_editor_login_popup_login_${source}`, 'RT App', `Login Page: Logged in through ${source}`);
                }else if(res.account_type == 'new'){
                    ga4Track(`app_all_sign_up_points_user_signup`, 'RT App', 'User Signs Up');
                    ga4Track(`app_signup_user_signs_up`, 'RT App', 'Login Page: Signed up through page');
                    ga4Track(`app_signup_user_signs_up_${source}`, 'RT App', `Login Page: Signed up through ${source}`);
                }
            }
        }else if (props.hasOwnProperty('type') && props.type === 'coverletter_page') {
            if(res.msg == 'success'){
                if(res.account_type == 'returning'){
                    ga4Track(`app_all_login_points_user_logins`, 'RT App', 'CoverLetter User Logs In');
                    ga4Track(`app_coverletter_login_logged_in`, 'RT App', 'CoverLetter Login Popup: Logged in through page');
                    ga4Track(`app_coverletter_login_logged_in_${source}`, 'RT App', `Login Page: Logged in through ${source}`);
                }else if(res.account_type == 'new'){
                    ga4Track(`app_all_sign_up_points_user_signup`, 'RT App', 'User Signs Up');
                    ga4Track(`app_coverletter_login_signup`, 'RT App', 'CoverLetter Login Page: Signed up through page');
                    ga4Track(`app_coverletter_login_signup_${source}`, 'RT App', `CoverLetter Login Page: Signed up through ${source}`);
                }
            }
        }
        // send data to the FullStory
        // if(ENV == 'prod') fullStoryIdentify(res.user.email);
    }

    const saveHandler = () => {
        //const dashboardTab = (jsCookie.get('dashboard_tab', {domain: COOKIE_DOMAIN, path: "/"}) ?? "resume")
        if (props.hasOwnProperty('type') && props.type === 'popup') {
            if(entityType == 'resume')
                WpAPI.saveState(store.getState(), true, false)
        }
    }

    const dataReloadHandler = () => {
        //const dashboardTab = (jsCookie.get('dashboard_tab', {domain: COOKIE_DOMAIN, path: "/"}) ?? "resume")
        if (props.hasOwnProperty('type') && props.type === 'popup') {
            if(window.location.pathname == '/'){
                if(entityType == 'resume')
                    WpAPI.loadResumesInDashboard(props.setEntities)
                else if(entityType == 'coverletter')
                    WpAPI.loadCoverLettersInDashboard(props.setEntities)
            }
        }
    }

    const lastActionHandler = () => {
        if (props.hasOwnProperty('type') && props.type === 'popup') {
            if(window.location.pathname == '/'){
                setTimeout(() => {
                    triggerLastAction();
                }, 300);
            }else{
                triggerLastAction();
            }
        }
    }

    const finalActionsHandler = () => {
        if (props.hasOwnProperty('type') && props.type === 'popup') {
            props.setShowLoginPopUp(false)
        }else if (props.hasOwnProperty('type') && props.type === 'page') {
            checkMembershipAction()
            history.push(props.redirect)
        }else if (props.hasOwnProperty('type') && props.type === 'coverletter_page') {
            // checkMembershipAction()
            // window.location.href = '/coverletter/finalize'
            // props.loginInitiationCompleted();
            props.loginSuccessfullyCompleted()
            // target.innerHTML = "Generate Cover Letter"
        }
    }
    const buttonClickHandler = () => {
        // if(props.type == 'page'){
        //     setTimeout(() => {history.push('/login-progress/')}, 1000)
        // }else if(props.type == 'popup'){
        //     props.setIsLoading(true)
        // }
        props.setIsLoading(true)
    }

    const errorHandler = () => {
        const formTitle = localStorage.getItem('formTitle')
        localStorage.removeItem('formTitle')
        localStorage.setItem('loginError', encryptData({msg: `${formTitle} failed. Please try again.`}))
        // if(props.hasOwnProperty('type') && props.type == 'page'){
        //     window.location.href = `${APP_DOMAIN}${LOGIN_LINK}`
        // }else if(props.hasOwnProperty('type') && props.type == 'popup'){
        //     mounted.current && props.setIsLoading(false)
        // }
        mounted.current && props.setIsLoading(false)
    }

    return (
        <div className="social-login">
            <LoginSocialGoogle
                client_id={SOCIAL_LOGIN_GG_CLIENT_ID || ''}
                redirect_uri={REDIRECT_URI}
                scope="openid profile email"
                discoveryDocs="claims_supported"
                access_type="online"
                onResolve={({ provider, data }) => {
                    dispatch(socialLoginAction(data, 'Google'))
                    .then(res => {
                        WpAPI.linklocalResumeToUser()
                        // update user and memberhip data afer a successful signup
                        updateStateUserAndMembership()
                        return res
                    // }).then(res => {
                    //     WpAPI.linkLocalCoverLetterToUser(dispatch).then(resp => {
                    //         // const dasboardTab = (Cookies.get('dashboard_tab', {domain: COOKIE_DOMAIN, path: "/"}) ?? "resume")
                    //         // props.LoginSignupCallback(dasboardTab, props.type, 'login', 'google', res, triggerLastAction, checkMembershipAction, fullStoryIdentify)
                    //         postLoginHandlers(res)
                    //     })
                    //     return res
                    }).then(res => WpAPI.fetchActiveResume(dispatch, () => {
                        //if(res.msg == 'success') WpAPI.saveState(store.getState(), true, false);
                        // const dasboardTab = (Cookies.get('dashboard_tab', {domain: COOKIE_DOMAIN, path: "/"}) ?? "resume")
                        // props.LoginSignupCallback(dasboardTab, props.type, 'login', 'google', res, triggerLastAction, checkMembershipAction, fullStoryIdentify)
                        postLoginHandlers(res, 'Google' )
                        /*
                        if(props.hasOwnProperty('type') && props.type == 'popup'){
                            if(res.msg == 'success'){
                                WpAPI.saveState(store.getState(), true, false)
                                // checkMembershipAction();
                                if(res.user?.track_firstlogin){
                                    if(res.user.track_firstlogin == 'yes' && res.user.rb_firstlogin == 'yes'){
                                        let date = new Date().toJSON();
                                        ga4Track('app_registered_user_first_login', 'RT App', `Registered User: First Login, Path:${window.location.pathname}, Email:${res.user.email}, Date:${date}`);
                                    }
                                }
                                if(res.account_type == 'returning'){
                                    ga4Track(`app_all_login_points_user_logins`, 'RT App', 'User Logs In');
                                    ga4Track(`app_editor_login_popup_login`, 'RT App', 'Login Popup: Logged in through popup');
                                    ga4Track(`app_editor_login_popup_login_google`, 'RT App', 'Login Popup: Logged in through Google');
                                }else if(res.account_type == 'new'){
                                    ga4Track(`app_all_sign_up_points_user_signup`, 'RT App', 'User Signs Up');
                                    ga4Track(`app_editor_login_popup_signup`, 'RT App', 'Login Popup: Signed up through popup');
                                    ga4Track(`app_editor_login_popup_signup_google`, 'RT App', 'Login Popup: Signed up through Google');
                                }
                            }
                            if(window.location.pathname == '/'){
                                WpAPI.loadResumesInDashboard(props.setResumes);
                                setTimeout(() => {
                                    triggerLastAction();
                                }, 300);
                            }else{
                                triggerLastAction();
                            }
                            props.setShowLoginPopUp(false);
                            if(ENV == 'prod') fullStoryIdentify(res.user.email);
                        }
                        */
                        /*
                        if(props.hasOwnProperty('type') && props.type == 'page'){
                            if(res.msg == 'success'){
                                checkMembershipAction();
                                if(res.user?.track_firstlogin){
                                    if(res.user.track_firstlogin == 'yes' && res.user.rb_firstlogin == 'yes'){
                                        let date = new Date().toJSON();
                                        ga4Track('app_registered_user_first_login', 'RT App', `Registered User: First Login, Path:${window.location.pathname}, Email:${email}, Date:${date}`);
                                    }
                                }
                                if(res.account_type == 'returning'){
                                    ga4Track(`app_all_login_points_user_logins`, 'RT App', 'User Logs In');
                                    ga4Track(`app_editor_login_logged_in`, 'RT App', 'Login Page: Logged in');
                                    ga4Track(`app_editor_login_logged_in_google`, 'RT App', 'Login Page: Logged in through Google');
                                }else if(res.account_type == 'new'){
                                    ga4Track(`app_all_sign_up_points_user_signup`, 'RT App', 'User Signs Up');
                                    ga4Track(`app_editor_login_signed_up`, 'RT App', 'Login Page: Signed up');
                                    ga4Track(`app_editor_login_signed_up_google`, 'RT App', 'Login Page: Signed up through Google');
                                }
                                if(ENV == 'prod') fullStoryIdentify(res.user.email);
                                //history.push(props.redirect)
                                window.location.href = `${APP_DOMAIN}/${props.redirect}`
                            } 
                        }
                        */
                    })).catch((e) => {
                        setmsg(e)
                        // target.innerHTML = (props?.type == 'coverletter_page' ? "Generate Cover Letter": "Log In")
                        props?.type == 'coverletter_page' && props.loginInitiationInterrupted();
                        console.log('Caught', e)
                        errorHandler()
                    })
                }}
                onReject={err => {
                    console.log('Rejected', err)
                    errorHandler()
                }}
                onLoginStart={() => {
                    localStorage.setItem('formTitle', props.label)
                }}
                >
                <div className="google-login" onClick={buttonClickHandler}>
                    <i className="google"><GoogleImage /></i>
                    <span>{`${props.label} with Google`}</span>
                </div>
            </LoginSocialGoogle>
            {/* <LoginSocialFacebook
                appId={SOCIAL_LOGIN_FB_APP_ID || ''}
                fieldsProfile={
                    'id,first_name,last_name,middle_name,name,name_format,picture,short_name,email,gender'
                }
                redirect_uri={REDIRECT_URI}
                onResolve={({ provider, data }) => {
                    dispatch(socialLoginAction(data, 'Facebook'))
                    .then(res => {
                        WpAPI.linklocalResumeToUser()
                        // update user and memberhip data afer a successful signup
                        updateStateUserAndMembership()
                        return res
                    }).then(res => WpAPI.fetchActiveResume(dispatch, () => {
                        postLoginHandlers(res, 'Facebook')
                    })).catch((e) => {
                        setmsg(e)
                        props?.type == 'coverletter_page' && props.loginInitiationInterrupted();
                        console.log('Caught', e)
                        errorHandler()
                    })
                }}
                onReject={err => {
                    console.log('Rejected', err)
                    errorHandler()
                }}
                onLoginStart={() => {
                    localStorage.setItem('formTitle', props.label)
                }}
                >
                <div className="fb-login" onClick={buttonClickHandler}>
                    <i className="fb"><FbImage /></i>
                </div>
            </LoginSocialFacebook> */}
            
            {/* <div className="apple-login">
                <i className="apple"><AppleImage /></i>
            </div> */}
        </div>
    );
}

export default SocialLogin;